
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24Wifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10c2.382-.008 4.671.893 6.363 2.508a1.012 1.012 0 0 1 .231 1.168c-.093.2-.245.362-.431.47a1.15 1.15 0 0 1-.648.154 1.127 1.127 0 0 1-.774-.319 6.837 6.837 0 0 0-4.742-1.892c-1.78 0-3.485.681-4.741 1.891a1.124 1.124 0 0 1-.779.308c-.281 0-.563-.102-.778-.307a1.023 1.023 0 0 1-.317-.737c0-.267.106-.534.316-.737 1.676-1.599 3.94-2.5 6.3-2.507z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.998 5c3.74.01 7.326 1.435 9.98 3.97.205.196.322.463.322.743 0 .279-.117.546-.323.742-.208.199-.49.31-.786.308a1.127 1.127 0 0 1-.784-.307C18.085 8.226 15.042 7.11 12 7.11c-3.043 0-6.086 1.116-8.409 3.346-.216.208-.5.312-.784.312-.284 0-.568-.104-.785-.312a1.028 1.028 0 0 1-.321-.743c0-.27.107-.539.32-.743C4.675 6.435 8.26 5.01 11.999 5z",
  fill: "#000"
}))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M12 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"M12 10c2.382-.008 4.671.893 6.363 2.508.161.153.265.346.305.55.04.204.017.42-.074.618-.093.2-.245.362-.431.47-.188.11-.41.167-.648.154a1.127 1.127 0 0 1-.774-.319 6.837 6.837 0 0 0-4.742-1.892c-1.78 0-3.485.681-4.741 1.891a1.124 1.124 0 0 1-.779.308c-.281 0-.563-.102-.778-.307a1.023 1.023 0 0 1-.317-.737c0-.267.106-.534.316-.737C7.376 10.908 9.64 10.007 12 10z\" fill=\"#000\"/>\r\n        <path d=\"M11.998 5c3.74.01 7.326 1.435 9.98 3.97.205.196.322.463.322.743 0 .279-.117.546-.323.742-.208.199-.49.31-.786.308a1.127 1.127 0 0 1-.784-.307C18.085 8.226 15.042 7.11 12 7.11c-3.043 0-6.086 1.116-8.409 3.346-.216.208-.5.312-.784.312-.284 0-.568-.104-.785-.312a1.028 1.028 0 0 1-.321-.743c0-.27.107-.539.32-.743C4.675 6.435 8.26 5.01 11.999 5z\" fill=\"#000\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-wifi.9bdd8d639ec7db2329a6d1f24d6f2a6c.svg"),
        {
          React: SvgIcon24Wifi,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      